import Module from './Module';

const module = new Module('places', '/api/v1/places', true);

export const {
  get, getById, save, remove, resetState, resetSuccessSave,
} = module;

export default module.reducer;



// WEBPACK FOOTER //
// ./src/modules/places.js